import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="footer-copyright">
            <p>
              Copyright © {year} stonyango
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;